export default {
      id: "kalkun-usage",
      viewBox: "0 0 124 68",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#kalkun",
      toString: function () {
        return this.url;
      }
    }